import { createAction, props } from '@ngrx/store';
import { ActivityRecordVerificationStatus } from '../../data-model/enums/activity-record-verification-status.enum';
import { ActivitySummaryFilter } from '../../data-model/models/activity-summary-filter.model';
import { CloseEventRequest } from '../../data-model/models/close-event-request.model';
import { OssActivityRecord } from '../../data-model/models/oss-activity-record.model';

const feature = '[Activity]';

export const loadActivityRecords = createAction(`${feature} Load Activity Records`, props<{ fetchActivityRecords: boolean }>());
export const activityRecordsLoaded = createAction(
  `${feature} Activity Records Loaded`,
  props<{ activityRecords: OssActivityRecord[]; numberOfActivityRecords: number }>()
);

export const exportActivityRecords = createAction(`${feature} Export Activity Records`);
export const activityRecordsExported = createAction(`${feature} Activity Records Exported`);

export const exportMissingActivityRecords = createAction(`${feature} Export Missing Activity Records`);
export const missingActivityRecordsExported = createAction(`${feature} Missing Activity Records Exported`);

export const setVerificationStatus = createAction(
  `${feature} Set Verification Status`,
  props<{ verificationStatus: ActivityRecordVerificationStatus; fetchActivityRecords: boolean }>()
);
export const setLimit = createAction(`${feature} Set Limit`, props<{ limit: number; fetchActivityRecords?: boolean }>());
export const setOffset = createAction(`${feature} Set Offset`, props<{ offset: number; fetchActivityRecords?: boolean }>());
export const setFilter = createAction(`${feature} Set Filter`, props<{ filter: ActivitySummaryFilter; fetchActivityRecords?: boolean }>());

export const loadMissingActivityRecords = createAction(`${feature} Load Missing Activity Records`);
export const missingActivityRecordsLoaded = createAction(`${feature} Missing Activity Records Loaded`, props<{ numberOfMissingActivityRecords: number }>());

export const closeItem = createAction(`${feature} Close Item`, props<{ request: CloseEventRequest }>());
export const itemClosed = createAction(`${feature} Item Closed`);

export const deleteItem = createAction(`${feature} Delete Item`, props<{ activityId: number }>());
export const itemDeleted = createAction(`${feature} Item Deleted`);

export const resetActivityState = createAction(`${feature} Reset Activity State`);
